export class PayOffered {
    public offeredPayRate!: number;
    public offeredPayRateUOM!: string;
}

